import React, { ReactElement } from "react";
import { StepProps } from "./base";

const ROLES = [
    { title: "Customer Support", id: "customer-support" },
    { title: "Information Technology (IT)", id: "it" },
    { title: "Human Resources (HR)", id: "hr" },
    { title: "Security", id: "security" },
    { title: "Legal", id: "legal" },
    { title: "Engineering", id: "engineering" },
    { title: "Other", id: "other" },
];
export default function OnboardingStep(props: StepProps): ReactElement {
    return (
        <div className="w-100">
            <h2>Welcome to Foqal</h2>
            <p>
                Welcome to Foqal Agent, to better let Foqal tailor your needs, we
                ask you just a few questions to help you get started. Don&apos;t worry
                you will be able to get back to all of these settings after you are done.
            </p>
            <h4 className="mt-3">What is your role?</h4>
            <ul className="list-group">
                {ROLES.map(role => (
                    <button
                        type="button"
                        className="list-group-item list-group-item-action"
                        key={role.id}
                        onClick={props.onNext}
                    >
                        {role.title}
                    </button>
                ))}
            </ul>
        </div>
    );
}
